import React from "react";
import { Lock, Check } from "lucide-react";
import { THEMES } from "./QuotePreview";

const LABELS = { basic: ["Basic", "Free"], modern: ["Modern", "Starter"], premium: ["Premium", "Pro"], signature: ["Signature", "Heavy"] };

const Mini = ({ t }) => {
  const img = t.img;
  return (
    <div className="relative w-full overflow-hidden rounded-sm" style={{ aspectRatio: "8.5 / 11", backgroundColor: t.bg, ...(img ? { backgroundImage: `url(${img.paper})`, backgroundSize: "100% 100%" } : {}) }}>
      {img ? <img src={img.header} alt="" className="w-full block" /> : (
        <><div style={{ height: "16%", backgroundColor: t.primary }} /><div style={{ height: "2%", backgroundColor: t.accent }} /></>
      )}
      <div className="px-[10%] pt-[8%] space-y-[6%]">
        <div style={{ height: 4, width: "55%", backgroundColor: t.primary, opacity: 0.85 }} />
        {[0, 1, 2].map((i) => <div key={i} style={{ height: 1, backgroundColor: t.hair }} />)}
      </div>
      <div className="absolute left-[10%] right-[10%] bottom-[16%]" style={{ aspectRatio: "504 / 60", ...(img ? { backgroundImage: `url(${img.bar})`, backgroundSize: "100% 100%" } : { backgroundColor: t.pale }) }} />
    </div>
  );
};

export const TemplatePicker = ({ value, onChange, allowed, onLocked }) => (
  <div className="grid grid-cols-4 gap-2" data-testid="template-picker">
    {Object.keys(LABELS).map((k) => {
      const ok = allowed.includes(k);
      const sel = value === k;
      return (
        <button
          key={k}
          type="button"
          data-testid={ok ? `template-option-${k}` : `template-locked-${k}`}
          onClick={() => (ok ? onChange(k) : onLocked())}
          className={`relative rounded-lg p-1.5 bg-white/80 border-2 text-left transition-[border-color,transform] duration-200 hover:-translate-y-0.5 ${sel ? "border-[#A6844A] shadow-md" : "border-transparent hover:border-[#D5CFC2]"}`}
        >
          <div className={ok ? "" : "opacity-60"}><Mini t={THEMES[k]} /></div>
          {sel && <span className="absolute top-2 right-2 rounded-full bg-[#A6844A] text-white p-0.5"><Check className="w-3 h-3" /></span>}
          {!ok && <span className="absolute inset-0 flex items-center justify-center"><span className="rounded-full bg-[#1B3A4B] text-white p-1.5"><Lock className="w-3.5 h-3.5" /></span></span>}
          <div className="mt-1.5 text-[11px] font-semibold text-[#1C1915] leading-tight">{LABELS[k][0]}</div>
          <div className="text-[10px] text-[#5C564E] leading-tight">{LABELS[k][1]}</div>
        </button>
      );
    })}
  </div>
);
